import type { BaseRoleEntity } from '@/features/baseRole/domain/entities/BaseRoleEntity'
import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'
import type { RoleEntity } from '@/features/role/domain/entities/RoleEntity'

export class UsersFilterEntity {
  id?: string
  searchWord?: string
  region?: RegionMiniEntity
  role?: RoleEntity
  baseRole?: BaseRoleEntity
  hasOrder?: boolean
  birthDate?:Date[]
  date?: Date[]
  page?: number
  limit?: number
  sortField?: string
  sortDescending?: boolean
}
